export default "__VITE_ASSET__BkyWkDuk__"